
import {
  Address, UpdatePaymentCardInput,
  payOutstandingBalance, setUserBillingAddress,
  updateAutopayStatus, updatePaymentCard, ClientCard,
} from '@uplift/api';
import { DateObject } from '@uplift/services';
import { AddressTypeWithStateProfileType } from '@uplift/ui-v2';


export type CardExpirationStatusType = 'expiresSoon' | 'expired' | null;
export type CardDeclinedStatusType = 'declined' | null;


export type BillingDataType = {
  cardBrand: ClientCard['brand'];
  cardHolderName: ClientCard['billingDetails']['name'];
  expireSoon: boolean;
  expiration: DateObject;
  last4: ClientCard['last4'];
  expire: ClientCard['expire'];
  declined: ClientCard['declined'];
  outstandingBalance: number | null;
  outstandingPaymentsCount: number;
  declinedPaymentsCount: number;
  autopayEnabled: boolean;
  expirationStatus: CardExpirationStatusType;
  declinedStatus: CardDeclinedStatusType;
  userBillingId: string;
  lastCompletedPaymentAt: string | null;
} & AddressTypeWithStateProfileType;


export const useSaveBilling = () => {
  const insertBilling = async (billingUpdates: Address) => {
    try {
      await setUserBillingAddress(billingUpdates);

      return true;
    } catch (error) {
      console.error(error);

      return null;
    }
  };

  const savePaymentCard = async (paymentCardUpdates: UpdatePaymentCardInput) => {
    try {
      return await updatePaymentCard(paymentCardUpdates);
    } catch (error) {
      console.error(error);

      return null;
    }
  };

  const saveAutopayStatus= async (autopayStatus) => {
    try {
      return await updateAutopayStatus(autopayStatus);
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const payBalance = async (resourceIds: null | string[]) => {
    try {
      return await payOutstandingBalance(resourceIds);
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return { savePaymentCard, insertBilling, saveAutopayStatus, payBalance };
};
